// App.jsx
import { Inject, HtmlEditor, Image, Link, QuickToolbar, RichTextEditorComponent } from '@syncfusion/ej2-react-richtexteditor';
import * as React from 'react';

const HTMLPreview = ({ rteValue }) => {
// const rteValue = '<p>Welcome to Syncfusion Rich Text Editor</p>'; // Initial HTML content
  const iframe = { enable: true };
  return (
    <div className="m-2 md:m-10 mt-24 p-2 md:p-10 bg-white rounded-3xl zackat-div">
      <h2>Syncfusion Rich Text Editor</h2>
      <RichTextEditorComponent
        value={rteValue}
        iframeSettings={iframe}
      >
        <Inject services={[Image, Link, HtmlEditor, QuickToolbar]} />
      </RichTextEditorComponent>
    </div>
  );
};
export default HTMLPreview;
